import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  role: "banner",
  class: "flex items-center justify-between p-8 sticky bg-slate-200 dark:bg-gray-900 text-gray-900 dark:text-slate-200"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "sr-only" }, "Personal website of Parth Shah, Software Engineer.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-14 w-14 flex justify-center items-center text-4xl bg-pink-900 dark:bg-yellow-400 text-slate-200 dark:text-gray-900" }, " S ", -1)
const _hoisted_4 = {
  class: "flex flex-wrap justify-center gap-x-20",
  "aria-label": "main navigation"
}

import "@/assets/css/main.css";
import { RouterLink } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const nav = [
  {
    name: "Home",
    path: "/",
    ariaLabel: "Navigate to Home",
  },
  {
    name: "About",
    path: "/about",
    ariaLabel: "Navigate to About",
  },
  {
    name: "Projects",
    path: "/projects",
    ariaLabel: "Navigate to Projects",
  },
];

// var themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
// var themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');

// // Change the icons inside the button based on previous settings
// if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
//     themeToggleLightIcon.classList.remove('hidden');
// } else {
//     themeToggleDarkIcon.classList.remove('hidden');
// }

// var themeToggleBtn = document.getElementById('theme-toggle');

// themeToggleBtn.addEventListener('click', function() {

//     // toggle icons inside button
//     themeToggleDarkIcon.classList.toggle('hidden');
//     themeToggleLightIcon.classList.toggle('hidden');

//     // if set via local storage previously
//     if (localStorage.getItem('color-theme')) {
//         if (localStorage.getItem('color-theme') === 'light') {
//             document.documentElement.classList.add('dark');
//             localStorage.setItem('color-theme', 'dark');
//         } else {
//             document.documentElement.classList.remove('dark');
//             localStorage.setItem('color-theme', 'light');
//         }

//     // if NOT set via local storage previously
//     } else {
//         if (document.documentElement.classList.contains('dark')) {
//             document.documentElement.classList.remove('dark');
//             localStorage.setItem('color-theme', 'light');
//         } else {
//             document.documentElement.classList.add('dark');
//             localStorage.setItem('color-theme', 'dark');
//         }
//     }
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(RouterLink), {
      to: "/",
      class: "justify-center"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("nav", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nav, (n, i) => {
        return _createVNode(_unref(RouterLink), {
          key: { i },
          to: n.path,
          class: "pt-8 uppercase hover:-translate-y-2 transition-transform duration-300 ease-in-out",
          "aria-label": n.ariaLabel,
          "aria-current": n.path === _ctx.$route.path ? 'page' : null
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(n.name), 1)
          ]),
          _: 2
        }, 1032, ["to", "aria-label", "aria-current"])
      }), 64))
    ])
  ]))
}
}

})